module.exports = "https://static.zego.com/_next/static/images/private-hire-15eb36953f680e89a9c9b62fc7dd8535.svg";